import { render, staticRenderFns } from "./MessageResultDetails.vue?vue&type=template&id=5b5f0c5b"
import script from "./MessageResultDetails.vue?vue&type=script&lang=js"
export * from "./MessageResultDetails.vue?vue&type=script&lang=js"
import style0 from "./MessageResultDetails.vue?vue&type=style&index=0&id=5b5f0c5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports